// extracted by mini-css-extract-plugin
export var fulfillmentFooter = "_3m-0";
export var product = "_3m-1";
export var productImage = "_3m-2";
export var productTitle = "_3m-3";